import {
  GET_PARTNERS,
  POST_PARTNER,
  DELETE_PARTNER,
  UPDATE_PARTNER,
  ERROR_PARTNERS,
  MESSAGE_PARTNERS
} from "../actions/types"

const initialState = {
  partnersList: null,
  error: null,
  message: null
};

export default function partnersReducer(state = initialState, action) {

  var partnersList = state.partnersList;

  switch (action.type) {

    case POST_PARTNER:
      if (!partnersList) partnersList = [];
      partnersList.push(action.payload.partner);
      return { ...state, partnersList, message: action.payload.message };

    case UPDATE_PARTNER:
      if (partnersList) {
        var index = partnersList.findIndex(p => p._id === action.payload.partner._id);
        if (index >= 0) {
          partnersList[index] = action.payload.partner;
        }
      } else {
        partnersList = [action.payload.partner];
      }
      return { ...state, partnersList, message: action.payload.message };

    case GET_PARTNERS:
      return { ...state, partnersList: action.payload };

    case DELETE_PARTNER:
      partnersList = state.partnersList.filter(p => p._id !== action.payload);
      return { ...state, partnersList };

    case MESSAGE_PARTNERS:
      return { ...state, message: action.payload };

    case ERROR_PARTNERS:
      return { ...state, error: action.payload };

    default:
      return { ...state };
  }
}
